if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!Number(this.endDate)) return;

      this.isPaused = false;
      

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

            
      this.playBtn = this.querySelector('.js-countdown-play');
      this.pauseBtn = this.querySelector('.js-countdown-pause');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.setupControls();

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    setupControls() {
      if (this.playBtn && this.pauseBtn) {
        this.playBtn.addEventListener('click', () => this.resume());
        this.pauseBtn.addEventListener('click', () => this.pause());
        
        // Initially show pause button, hide play button
        this.playBtn.style.display = 'none';
        this.pauseBtn.style.display = 'block';
      }
    }

    pause() {
      this.isPaused = true;
      
      if (this.playBtn && this.pauseBtn) {
        this.playBtn.style.display = 'block';
        this.pauseBtn.style.display = 'none';
      }
    }

    resume() {
      if (this.isPaused) {
        this.isPaused = false;
        
        // Immediately update the display to show the accurate current time
        this.timer();
        
        if (this.playBtn && this.pauseBtn) {
          this.playBtn.style.display = 'none';
          this.pauseBtn.style.display = 'block';
        }
      }
    }


    timer() {
      if (this.isPaused) {
        return; // Don't update when paused
      }
      
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      this.daysEl.textContent = days;
      this.hoursEl.textContent = hours - days * 24;
      this.minsEl.textContent = mins - hours * 60;
      this.secsEl.textContent = secs - mins * 60;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
